"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pushEvent = exports.initObservability = exports.ErrorBoundary = void 0;
var faro_react_1 = require("@grafana/faro-react");
Object.defineProperty(exports, "ErrorBoundary", { enumerable: true, get: function () { return faro_react_1.FaroErrorBoundary; } });
var init_1 = require("./init");
Object.defineProperty(exports, "initObservability", { enumerable: true, get: function () { return init_1.initObservability; } });
Object.defineProperty(exports, "pushEvent", { enumerable: true, get: function () { return init_1.pushEvent; } });
